import { styled } from '@linaria/react';
import { Badge } from '../../components/Badge';
import { colors, fonts, layout, semantic, space } from '../../theme/tokens';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
  width: 100%;

  @media (min-width: ${layout.desktopBreakpoint}) {
    overflow: visible;
  }
`;

export const ScrollArea = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: calc(${layout.mobileNavHeight} + ${space[10]});

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding-bottom: 0;
  }
`;

export const HeaderGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[4]};
`;

export const UrgencyBadge = styled(Badge)`
  align-self: flex-end;
`;

export const Title = styled.h1`
  font-family: ${fonts.heading};
  font-size: ${fonts.size['2xl']};
  font-weight: ${fonts.weight.normal};
  color: ${semantic.text.primary};
  margin: 0;
  line-height: 1.2;

  @media (min-width: ${layout.desktopBreakpoint}) {
    font-size: ${fonts.size['3xl']};
  }
`;

export const ItemsSection = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${space[3]};
  margin: ${space[6]} 0 0;
  padding: 0;
  list-style: none;

  @media (min-width: ${layout.desktopBreakpoint}) {
    margin-top: ${space[7]};
  }
`;

export const ItemsItem = styled.li`
  display: block;
`;

export const ShowMoreRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${space[5]};
`;

export const MetaLabel = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  line-height: 1.4;
  color: ${semantic.text.primary};
  margin: ${space[7]} 0 0;
`;

export const DescriptionSection = styled.div`
  margin-top: ${space[7]};
  font-size: ${fonts.size.base};

  ${MetaLabel} + & {
    margin-top: ${space[4]};
  }
`;

export const TriggerSection = styled.div`
  margin-top: ${space[7]};
`;

export const TriggerRow = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: ${space[5]} 0;
  background: none;
  border: none;
  border-bottom: 1px solid ${semantic.border.default};
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
  cursor: pointer;
  text-align: left;

  &:focus-visible {
    outline: 2px solid ${colors.primary};
    outline-offset: 2px;
  }
`;

export const NotificationSection = styled.div`
  margin-top: ${space[5]};
`;

export const ActionBarArea = styled.div`
  @media (min-width: ${layout.desktopBreakpoint}) {
    position: sticky;
    bottom: 0;
    background: ${colors.white};
    border-top: 1px solid ${semantic.border.default};
    padding-bottom: ${space[5]};
  }
`;

export const Spacer = styled.div`
  height: ${space[6]};
`;
